document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-cart-drawer]');
  const panel = drawer?.querySelector('[data-cart-drawer-panel]');
  const content = drawer?.querySelector('[data-cart-drawer-content]');

  const giftWrapVariantId = Number(
    drawer?.dataset.giftWrapVariantId || 0
  );

  const giftWrapPrice = Number(
    drawer?.dataset.giftWrapPrice || 0
  );

  if (!drawer || !panel || !content) return;

  let previouslyFocusedElement = null;
  let isUpdating = false;
  const submittingForms = new WeakSet();
  const giftMessageField = window.CartController.createAutosaveField({
    delay: 500,
    maximum: 300,
    getCount(textarea) {
      return textarea
        .closest('[data-cart-drawer-gifting]')
        ?.querySelector('[data-cart-drawer-gift-count]');
    },
    onSave(textarea) {
      return saveGiftMessage(textarea).catch(function () {});
    }
  });

  const orderNoteField = window.CartController.createAutosaveField({
    delay: 500,
    getCount(textarea) {
      return textarea
        .closest('.cart-drawer__order-note')
        ?.querySelector('[data-cart-drawer-order-note-count]');
    },
    onSave(textarea) {
      return saveOrderNote(textarea);
    }
  });

  const formatMoney = window.CartUI.formatMoney.bind(window.CartUI);
  const escapeHtml = window.CartUI.escapeHtml.bind(window.CartUI);

  const requestStatus = window.CartController.createStatusRenderer({
    parent: content,
    className: 'cart-drawer__request-status',
    dataset: { cartDrawerRequestStatus: '' },
    role: 'alert',
    live: 'assertive'
  });

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function getFocusableElements() {
    return Array.from(
      panel.querySelectorAll(
        [
          'a[href]',
          'button:not([disabled])',
          'input:not([disabled])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"])'
        ].join(',')
      )
    ).filter(function (element) {
      return !element.hasAttribute('hidden');
    });
  }

  function dispatchCartUpdate(cart, source) {
    window.CartUI.dispatchUpdated(cart, source || 'cart-drawer');
  }

  function setUpdating(updating) {
    isUpdating = updating;

    window.CartUI.setBusy(content, updating, {
      className: 'is-updating',
      loadingSelector: '[data-cart-drawer-loading]',
      controlsSelector:
        '[data-cart-minus], [data-cart-plus], [data-cart-remove], [data-cart-quantity]'
    });
  }

  function openDrawer() {
    previouslyFocusedElement = document.activeElement;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');

    window.requestAnimationFrame(function () {
      panel.focus();
    });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');

    if (
      previouslyFocusedElement &&
      typeof previouslyFocusedElement.focus === 'function'
    ) {
      previouslyFocusedElement.focus();
    }
  }

  function createImageMarkup(item, title) {
    if (item.image) {
      const imageUrl = new URL(item.image, window.location.origin);
      imageUrl.searchParams.set('width', '360');

      return `
        <img
          src="${escapeAttribute(imageUrl.toString())}"
          alt="${escapeAttribute(title)}"
          loading="lazy"
          width="360"
          height="450"
        >
      `;
    }

    const fallbackUrl =
      window.cartDrawerFallbackImage ||
      '/assets/fallback.png';

    return `
      <img
        src="${escapeAttribute(fallbackUrl)}"
        alt="${escapeAttribute(title)}"
        loading="lazy"
        width="360"
        height="450"
      >
    `;
  }

  function createPreorderMarkup(item) {
    const properties = item.properties || {};
    const isPreorder = properties['Pre-order'] === 'Yes';

    if (!isPreorder) return '';

    const expectedDispatch = properties['Expected dispatch'];

    return `
      <div class="cart-drawer-item__preorder">
        <span class="cart-drawer-item__preorder-label">
          Pre-order
        </span>

        ${
          expectedDispatch
            ? `
              <span class="cart-drawer-item__preorder-message">
                ${escapeHtml(expectedDispatch)}
              </span>
            `
            : ''
        }
      </div>
    `;
  }

  function createPropertiesMarkup(item) {
    const properties = Object.entries(item.properties || {}).filter(
      function ([name, value]) {
        return (
          value &&
          name !== 'Pre-order' &&
          name !== 'Expected dispatch' &&
          !name.startsWith('_')
        );
      }
    );

    if (!properties.length) return '';

    const propertyRows = properties
      .map(function ([name, value]) {
        const valueMarkup = String(value).includes('/uploads/')
          ? `
            <a
              href="${escapeAttribute(value)}"
              target="_blank"
              rel="noopener"
            >
              View file
            </a>
          `
          : escapeHtml(value);

        return `
          <div class="cart-drawer-item__property">
            <dt>${escapeHtml(name)}</dt>
            <dd>${valueMarkup}</dd>
          </div>
        `;
      })
      .join('');

    return `
      <dl class="cart-drawer-item__properties">
        ${propertyRows}
      </dl>
    `;
  }

  function createDiscountsMarkup(item) {
    const allocations = item.line_level_discount_allocations || [];

    if (!allocations.length) return '';

    const discounts = allocations
      .map(function (allocation) {
        return `
          <li>
            ${escapeHtml(allocation.discount_application.title)}

            <span>
              −${formatMoney(allocation.amount)}
            </span>
          </li>
        `;
      })
      .join('');

    return `
      <ul class="cart-drawer-item__discounts">
        ${discounts}
      </ul>
    `;
  }

  function createItemMarkup(item, index) {
    const line = index + 1;
    const title = item.product_title || item.title || '';
    const productType = item.product_type || '';
    const itemUrl = item.url || '#';

    const variantMarkup =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `
          <p class="cart-drawer-item__variant">
            ${escapeHtml(item.variant_title)}
          </p>
        `
        : '';

    const comparePriceMarkup =
      item.original_line_price > item.final_line_price
        ? `
          <s class="cart-drawer-item__compare-price">
            ${formatMoney(item.original_line_price)}
          </s>
        `
        : '';

    return `
      <article
        class="cart-drawer-item"
        data-cart-key="${escapeAttribute(item.key)}"
        data-line="${line}"
      >
        <a
          href="${escapeAttribute(itemUrl)}"
          class="cart-drawer-item__media"
          tabindex="-1"
          aria-hidden="true"
        >
          ${createImageMarkup(item, title)}
        </a>

        <div class="cart-drawer-item__content">
          <div class="cart-drawer-item__heading">
            <div>
              ${
                productType
                  ? `
                    <p class="cart-drawer-item__eyebrow">
                      ${escapeHtml(productType)}
                    </p>
                  `
                  : ''
              }

              <a
                href="${escapeAttribute(itemUrl)}"
                class="cart-drawer-item__title"
              >
                ${escapeHtml(title)}
              </a>

              ${variantMarkup}
            </div>

            <button
              type="button"
              class="cart-drawer-item__remove"
              data-cart-remove
              data-line="${line}"
              data-key="${escapeAttribute(item.key)}"
              aria-label="Remove ${escapeAttribute(title)} from basket"
            >
              <svg
                viewBox="0 0 20 20"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M4 5H16"></path>
                <path d="M8 5V3H12V5"></path>
                <path d="M6 5L7 17H13L14 5"></path>
                <path d="M9 8V14"></path>
                <path d="M11 8V14"></path>
              </svg>
            </button>
          </div>

          ${createPreorderMarkup(item)}
          ${createPropertiesMarkup(item)}

          <div class="cart-drawer-item__bottom">
            <div
              class="cart-drawer-item__quantity"
              aria-label="Quantity for ${escapeAttribute(title)}"
            >
              <button
                type="button"
                data-cart-minus
                data-line="${line}"
                data-key="${escapeAttribute(item.key)}"
                aria-label="Decrease quantity"
              >
                <svg
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M3 8H13"></path>
                </svg>
              </button>

              <label
                class="visually-hidden"
                for="CartDrawerQuantity-${escapeAttribute(item.key)}"
              >
                Quantity for ${escapeHtml(title)}
              </label>

              <input
                id="CartDrawerQuantity-${escapeAttribute(item.key)}"
                type="number"
                value="${Number(item.quantity || 0)}"
                min="0"
                inputmode="numeric"
                data-cart-quantity
                data-line="${line}"
                data-key="${escapeAttribute(item.key)}"
                aria-label="Quantity"
              >

              <button
                type="button"
                data-cart-plus
                data-line="${line}"
                data-key="${escapeAttribute(item.key)}"
                aria-label="Increase quantity"
              >
                <svg
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M3 8H13"></path>
                  <path d="M8 3V13"></path>
                </svg>
              </button>
            </div>

            <div class="cart-drawer-item__prices">
              ${comparePriceMarkup}

              <p class="cart-drawer-item__price">
                ${formatMoney(item.final_line_price)}
              </p>
            </div>
          </div>

          ${createDiscountsMarkup(item)}
        </div>
      </article>
    `;
  }

  function createCartDiscountsMarkup(cart) {
    const discounts = cart.cart_level_discount_applications || [];

    if (!discounts.length) return '';

    const discountRows = discounts
      .map(function (discount) {
        return `
          <li>
            <span>${escapeHtml(discount.title)}</span>

            <strong>
              −${formatMoney(discount.total_allocated_amount)}
            </strong>
          </li>
        `;
      })
      .join('');

    return `
      <ul class="cart-drawer__discounts">
        ${discountRows}
      </ul>
    `;
  }

  function getGiftWrapItem(cart) {
    if (!giftWrapVariantId) return null;

    return cart.items.find(function (item) {
      return Number(item.variant_id) === giftWrapVariantId;
    }) || null;
  }

  function createOrderNoteMarkup(cart) {
    const note = cart.note || '';

    return `
      <div class="cart-drawer__order-note">
        <label for="CartDrawerOrderNote">
          Order notes
          <span>Optional</span>
        </label>

        <textarea
          id="CartDrawerOrderNote"
          rows="3"
          maxlength="500"
          placeholder="Add delivery instructions or other information…"
          data-cart-drawer-order-note
        >${escapeHtml(note)}</textarea>

        <div class="cart-drawer__order-note-footer">
          <span
            data-cart-drawer-order-note-status
            role="status"
            aria-live="polite"
          ></span>

          <span>
            <span data-cart-drawer-order-note-count>
              ${note.length}
            </span>/500
          </span>
        </div>
      </div>
    `;
  }

  function createGiftOptionsMarkup(cart) {
    const giftWrapItem = getGiftWrapItem(cart);
    const hasGiftWrap = Boolean(giftWrapItem);

    const attributes = cart.attributes || {};
    const giftMessage = attributes['Gift message'] || '';

    const unavailable = !giftWrapVariantId;

    return `
      <div
        class="cart-drawer__gifting"
        data-cart-drawer-gifting
      >
        <label class="cart-drawer__gift-toggle">
          <input
            type="checkbox"
            data-cart-drawer-gift-wrap
            ${hasGiftWrap ? 'checked' : ''}
            ${unavailable ? 'disabled' : ''}
          >

          <span
            class="cart-drawer__gift-checkbox"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 16 16"
              focusable="false"
              aria-hidden="true"
            >
              <path d="M3 8L6.5 11.5L13 4.5"></path>
            </svg>
          </span>

          <span class="cart-drawer__gift-copy">
            <strong>
              Add gift wrapping
            </strong>

            <span>
              ${
                unavailable
                  ? 'Gift wrapping is currently unavailable'
                  : formatMoney(giftWrapPrice)
              }
            </span>
          </span>
        </label>

        <div
          class="cart-drawer__gift-message"
          data-cart-drawer-gift-message-wrap
          ${hasGiftWrap ? '' : 'hidden'}
        >
          <label for="CartDrawerGiftMessage">
            Gift message
          </label>

          <textarea
            id="CartDrawerGiftMessage"
            maxlength="250"
            rows="3"
            placeholder="Write a message for the recipient"
            data-cart-drawer-gift-message
          >${escapeHtml(giftMessage)}</textarea>

          <div class="cart-drawer__gift-message-footer">
            <span
              class="cart-drawer__gift-status"
              data-cart-drawer-gift-status
              aria-live="polite"
            ></span>

            <span>
              <span data-cart-drawer-gift-count>
                ${giftMessage.length}
              </span>/250
            </span>
          </div>
        </div>
      </div>
    `;
  }

  function createLoadingMarkup() {
    return `
      <div
        class="cart-drawer__loading"
        data-cart-drawer-loading
        hidden
      >
        <span class="cart-drawer__loading-spinner"></span>
        <span>Updating your basket</span>
      </div>
    `;
  }

  function createEmptyMarkup() {
    return `
      ${createLoadingMarkup()}

      <div class="cart-drawer__empty">
        <div class="cart-drawer__empty-icon">
          <svg
            viewBox="0 0 48 48"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M12 17H36L34 40H14L12 17Z"></path>
            <path d="M18 19V14C18 10.7 20.7 8 24 8C27.3 8 30 10.7 30 14V19"></path>
            <path d="M24 33V23"></path>
            <path d="M24 27C20.7 27 18 24.3 18 21C21.3 21 24 23.7 24 27Z"></path>
            <path d="M24 24C27.3 24 30 21.3 30 18C26.7 18 24 20.7 24 24Z"></path>
          </svg>
        </div>

        <p class="cart-drawer__empty-eyebrow">
          Your basket is empty
        </p>

        <h3>
          Find something for your garden
        </h3>

        <p>
          Explore our collection of trees, shrubs and plants, thoughtfully
          selected for gardens of every size.
        </p>

        <a
          href="/collections/all"
          class="button cart-drawer__empty-button"
        >
          Shop all plants
        </a>

        <button
          type="button"
          class="cart-drawer__continue"
          data-cart-drawer-close
        >
          Continue browsing
        </button>
      </div>
    `;
  }

  function createPopulatedMarkup(cart) {
    const itemsMarkup = cart.items
      .map(function (item, index) {
        return createItemMarkup(item, index);
      })
      .join('');

    return `
      ${createLoadingMarkup()}

      <div class="cart-drawer__body">
        <div class="cart-drawer__items">
          ${itemsMarkup}
        </div>
      </div>

      <footer class="cart-drawer__footer">
        ${createOrderNoteMarkup(cart)}
        ${createGiftOptionsMarkup(cart)}

        <div class="cart-drawer__reassurance">
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M3 7H15V17H3Z"></path>
            <path d="M15 10H19L22 13V17H15Z"></path>
            <circle cx="7" cy="18" r="2"></circle>
            <circle cx="18" cy="18" r="2"></circle>
          </svg>

          <span>
            Carefully packed and delivered to your door
          </span>
        </div>

        <div class="cart-drawer__summary">
          <div class="cart-drawer__subtotal">
            <span>Subtotal</span>

            <strong data-cart-drawer-total>
              ${formatMoney(cart.total_price)}
            </strong>
          </div>

          ${createCartDiscountsMarkup(cart)}

          <p class="cart-drawer__note">
            Delivery and any applicable taxes are calculated at checkout.
          </p>
        </div>

        <div class="cart-drawer__actions">
          <a
            href="/cart"
            class="button button--secondary cart-drawer__view-cart"
          >
            View basket
          </a>

          <a
            href="/checkout"
            class="button cart-drawer__checkout"
            data-cart-drawer-checkout
          >
            <span>Checkout</span>

            <svg
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M3 10H17"></path>
              <path d="M12 5L17 10L12 15"></path>
            </svg>
          </a>
        </div>

        <div class="cart-drawer__secure">
          <svg
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
          >
            <rect x="4" y="8" width="12" height="9" rx="1"></rect>
            <path d="M7 8V6C7 4.3 8.3 3 10 3C11.7 3 13 4.3 13 6V8"></path>
          </svg>

          <span>Secure checkout</span>
        </div>
      </footer>
    `;
  }

  function renderCart(cart) {
    content.innerHTML = cart.items.length
      ? createPopulatedMarkup(cart)
      : createEmptyMarkup();

    const countElement = drawer.querySelector('[data-cart-drawer-count]');

    if (countElement) {
      countElement.textContent = cart.item_count;
    }
  }

  async function getCart() {
    return window.CartApi.get();
  }

  async function addGiftWrap() {
    return window.CartServices.addGiftWrap(giftWrapVariantId);
  }

  async function removeGiftWrap() {
    return window.CartServices.removeGiftWrap(giftWrapVariantId);
  }

  async function saveGiftAttributes(isGiftWrapped, message) {
    return window.CartServices.saveGiftAttributes(
      isGiftWrapped,
      message
    );
  }

  async function updateGiftWrap(checkbox) {
    if (isUpdating) return;

    const shouldAdd = checkbox.checked;

    const gifting = checkbox.closest(
      '[data-cart-drawer-gifting]'
    );

    const messageInput = gifting?.querySelector(
      '[data-cart-drawer-gift-message]'
    );

    const message = messageInput?.value.trim() || '';

    setUpdating(true);
    checkbox.disabled = true;

    try {
      let cart = shouldAdd
        ? await addGiftWrap()
        : await removeGiftWrap();

      cart = await saveGiftAttributes(
        shouldAdd,
        shouldAdd ? message : ''
      );

      renderCart(cart);
      dispatchCartUpdate(cart);
    } catch (error) {
      console.error(error);

      checkbox.checked = !shouldAdd;
      checkbox.disabled = false;

      const status = gifting?.querySelector(
        '[data-cart-drawer-gift-status]'
      );

      if (status) {
        status.textContent =
          error.message ||
          'Gift wrapping could not be updated.';
      }
    } finally {
      setUpdating(false);
    }
  }

  async function saveGiftMessage(textarea) {
    const gifting = textarea.closest(
      '[data-cart-drawer-gifting]'
    );

    const checkbox = gifting?.querySelector(
      '[data-cart-drawer-gift-wrap]'
    );

    const status = gifting?.querySelector(
      '[data-cart-drawer-gift-status]'
    );

    return window.CartController.saveGiftMessage({
      textarea,
      status,
      enabled: Boolean(checkbox?.checked),
      source: 'cart-drawer:gift-message'
    });
  }

  async function saveOrderNote(textarea) {
    const noteContainer = textarea.closest(
      '.cart-drawer__order-note'
    );

    const status = noteContainer?.querySelector(
      '[data-cart-drawer-order-note-status]'
    );

    return window.CartController.saveOrderNote({
      textarea,
      status,
      source: 'cart-drawer:note'
    });
  }

  async function refreshCart() {
    const cart = await getCart();

    renderCart(cart);
    dispatchCartUpdate(cart);

    return cart;
  }

  async function changeLine(key, quantity, context) {
    if (!key) return;

    const quantityInput = panel.querySelector(
      `[data-cart-quantity][data-key="${CSS.escape(key)}"]`
    );
    const lineState = window.CartController.createLineState({
      scopePrefix: 'cart-drawer-line',
      key,
      quantityInput
    });

    setUpdating(true);

    requestStatus.clear();

    try {
      const line = Number(context?.line || quantityInput?.dataset.line || 0);
      const cart = line
        ? await window.CartApi.changeLine(line, quantity)
        : await window.CartApi.change(key, quantity);

      if (
        !lineState.isLatest()
      ) {
        return;
      }

      renderCart(cart);
      dispatchCartUpdate(cart, 'cart-drawer:line-change');
    } catch (error) {
      if (
        !lineState.isLatest()
      ) {
        return;
      }

      console.error(error);

      try {
        await refreshCart();
      } catch (refreshError) {
        console.error(refreshError);
      }

      requestStatus.error(
        error,
        'We could not update your basket. Please try again.'
      );
    } finally {
      if (lineState.isLatest()) {
        setUpdating(false);
      }
    }
  }

  window.CartController.createLineControls({
    root: drawer,
    minusSelector: '[data-cart-minus]',
    plusSelector: '[data-cart-plus]',
    removeSelector: '[data-cart-remove]',
    quantitySelector: '[data-cart-quantity]',
    getInput(key, trigger) {
      const line = Number(trigger?.dataset.line || 0);

      if (line) {
        return content.querySelector(
          `[data-cart-quantity][data-line="${line}"]`
        );
      }

      return content.querySelector(
        `[data-cart-quantity][data-key="${CSS.escape(key)}"]`
      );
    },
    onChange(key, quantity, context) {
      changeLine(key, quantity, context);
    }
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    event.preventDefault();

    if (submittingForms.has(form)) return;
    submittingForms.add(form);

    const submitButton = form.querySelector(
      '[type="submit"][name="add"]'
    );

    const originalText = submitButton?.textContent || '';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding…';
    }

    try {
      await window.CartApi.addForm(new FormData(form));
      await refreshCart();
      openDrawer();
    } catch (error) {
      console.error(error);
      form.submit();
    } finally {
      submittingForms.delete(form);

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent =
          originalText.trim() || 'Add to cart';
      }
    }
  });

  drawer.addEventListener('click', async function (event) {
    const closeButton = event.target.closest(
      '[data-cart-drawer-close]'
    );

    const checkoutLink = event.target.closest(
      '[data-cart-drawer-checkout]'
    );

    if (checkoutLink) {
      const orderNote = drawer.querySelector(
        '[data-cart-drawer-order-note]'
      );

      if (!orderNote) return;

      event.preventDefault();
      try {
        await orderNoteField.flush(orderNote);
      } catch (error) {
        console.error(error);
      }

      window.location.href = checkoutLink.href;
      return;
    }

    if (closeButton) {
      closeDrawer();
      return;
    }

  });

  drawer.addEventListener('change', function (event) {
    const giftWrapToggle = event.target.closest(
      '[data-cart-drawer-gift-wrap]'
    );

    if (giftWrapToggle) {
      updateGiftWrap(giftWrapToggle);
      return;
    }

  });

  drawer.addEventListener('input', function (event) {
    const orderNote = event.target.closest(
      '[data-cart-drawer-order-note]'
    );

    if (orderNote) {
      orderNoteField.handleInput(orderNote);
      return;
    }

    const textarea = event.target.closest(
      '[data-cart-drawer-gift-message]'
    );

    if (!textarea) return;

    giftMessageField.handleInput(textarea);
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements();

    if (!focusableElements.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement =
      focusableElements[focusableElements.length - 1];

    if (
      event.shiftKey &&
      document.activeElement === firstElement
    ) {
      event.preventDefault();
      lastElement.focus();
    } else if (
      !event.shiftKey &&
      document.activeElement === lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  document.addEventListener('cart:open', async function () {
    try {
      await refreshCart();
      openDrawer();
    } catch (error) {
      console.error(error);
    }
  });
});